import SalaryHistoryCard from "./salaryHistoryCard"
export default SalaryHistoryCard;
